<template>
        <div class="py-4 style_two">
          <h4 class="mb-4 text-center font-active">Shop By Style</h4>
            <div>
              <ClientOnly>
                <Teleport  to="#teleports">
                  <div class="modal fade" data-bs-backdrop="true" id="modal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">           
                        <div class="modal-body">
                          <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg" /></div>
                          <div class="row">
                            <div class="col-lg-4 col-md-12">
                              <picture>
                                <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/halo.webp">
                                <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                  src="~/assets/home/style/halo.jpg" alt="Halo Engagement Rings">
                              </picture>
                            </div>
                            <div class="col-lg-8 col-md-12">
                              <h5 class="mb-0 font-active">Halo Engagement Rings</h5>
                              <h6 class="mb-0">Engagement rings with halos are crafted with round pavé or micro pavé set
                                diamonds circling the center diamond. These designs are an absolute beauty as the halos add
                                more sparkle to the ring while also putting the spotlight on the center gemstone and making it
                                appear larger. <br><br>
                                Some of these exquisite designs come with a hidden halo where the halo is crafted at the base
                                of the center stone, giving the ring an element of surprise. While halos around a round shaped
                                diamond are a classic choice, the recent trends also feature oval and pear shapes that tend to
                                gain wide popularity.
                              </h6>
                              <NuxtLink class="modal_link radious_four"
                                :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'halo-engagement-rings' } })">
                                Shop Halo Rings</NuxtLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Teleport>
                  <!-- 2 -->
                <Teleport  to="#teleports">
                  <div class="modal fade"  data-bs-backdrop="true" id="modal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">
                        <div class="modal-body">
                          <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg" /></div>
                          <!-- Vintage-->
                          <div class="row">
                            <div class="col-lg-4 col-md-12">
                              <picture>
                                <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/vintage.webp">
                                <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                  src="~/assets/home/style/vintage.jpg" alt="Halo Engagement Rings">
                              </picture>
                            </div>
                            <div class="col-lg-8 col-md-12">
                              <h5 class="mb-0 font-active">Vintage Engagement Rings</h5>
                              <h6 class="mb-0">
                                Vintage engagement rings are for those with a penchant for the beauty of the classic era.
                                These designs feature a rich aesthetic with intricate and detailed features that span through
                                the ripples of time.
                                <br><br>
                                While classic vintage rings usually feature Milgrain or Filigree artwork on their shank, some
                                modern ones may feature a twisted shank with accent diamonds placed aesthetically.
                                <br><br>
                                Inspired by the Victorian, Edwardian, Art Deco, and Retro eras, there is a design for every
                                vintage lover looking for the perfect lab diamond engagement ring!
    
                              </h6>
                              <NuxtLink class="modal_link radious_four"
                                :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'vintage-engagement-rings' } })">
                                Shop Vintage Engagement Rings</NuxtLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Teleport>  
                  <!-- 3 -->
                <Teleport  to="#teleports">   
                  <div class="modal fade" data-bs-backdrop="true" id="modal3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">                   
                        <div class="modal-body">
                          <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg" /></div>
                          <!-- solitare-->
                          <div class="row">
                            <div class="col-lg-4 col-md-12">
                              <picture>
                                <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/solitaire.webp">
                                <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                  src="~/assets/home/style/solitaire.jpg" alt="Solitaire Engagement Rings">
                              </picture>
                            </div>
                            <div class="col-lg-8 col-md-12">
                              <h5 class="mb-0 font-active">Solitaire Engagement Rings</h5>
                              <h6 class="mb-0">Solitaire engagement rings are a versatile and classic style with a single
                                sparkling diamond in the center. Their quintessential design puts all the focus on the center
                                gemstone.
                                <br><br>
                                Customizable in every way, you can choose your ideal lab diamond shape, metal type, and metal
                                color based on your preferences to craft your perfect solitaire ring. This style is
                                traditionally associated with a round diamond; however, incorporating fancy-shaped diamonds
                                such as hearts or ovals has been a popular contemporary trend.
                                <br><br>
                                Solitaire engagement rings typically feature plain solid metal bands. Nevertheless, they may
                                also have fancy bands in flat, thin, knife edge, and sometimes crisscross or twisted styles.
                              </h6>
                              <NuxtLink class="modal_link radious_four"
                                :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'solitaire-engagement-rings' } })">
                                Shop Solitaire Engagement Rings</NuxtLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Teleport>  
                  <!-- 4 -->
                <Teleport  to="#teleports">   
                  <div class="modal fade" data-bs-backdrop="true" id="modal4" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">                 
                        <div class="modal-body">
                          <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg" /></div>
                          <!--Three Stone E-->
                          <div class="row">
                            <div class="col-lg-4 col-md-12">
                              <picture>
                                <source width="280" height="280" type="image/webp"
                                  srcset="~/assets/home/style/three_stone.webp">
                                <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                  src="~/assets/home/style/three_stone.jpg" alt="Three Stone Engagement Rings">
                              </picture>
                            </div>
                            <div class="col-lg-8 col-md-12">
                              <h5 class="mb-0 font-active">Three Stone Engagement Rings</h5>
                              <h6 class="mb-0">Three stone diamond engagement rings are modern-day designs with a vintage
                                touch. Crafted with three main diamonds on the shank, each diamond symbolizes the couple's
                                eternal relationship, representing the past, present & forever of their journey.
                                <br><br>
                                Classic three stone engagement rings feature two round diamonds on each side of the center
                                stone. However, the contemporary trends feature a mix of traditional & modern-day artistry,
                                crafted with oval, emerald, or step cut diamonds like trapeziums and baguettes on both sides
                                of the center diamond.
                              </h6>
                              <NuxtLink class="modal_link radious_four"
                                :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'three-stone-engagement-rings' } })">
                                Shop Three Stone Engagement Rings</NuxtLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Teleport>  
                  <!-- 5 -->
                <Teleport  to="#teleports">   
                  <div class="modal fade" data-bs-backdrop="true" id="modal5" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">                
                        <div class="modal-body">
                          <div class="header_box" data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg"/></div>
                          <!-- Vintage-->
                          <div class="row">
                            <div class="col-lg-4 col-md-12">
                              <picture>
                                <source width="280" height="280" type="image/webp"
                                  srcset="~/assets/home/style/side_stone.webp">
                                <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                                  src="~/assets/home/style/side_stone.jpg" alt="Side Stone Engagement Rings">
                              </picture>
                            </div>
                            <div class="col-lg-8 col-md-12">
                              <h5 class="mb-0 font-active">Side Stone Engagement Rings</h5>
                              <h6 class="mb-0">Side stone diamond engagement rings are crafted with a set of diamonds on the
                                sides of the center gemstone. The side diamonds act as a perfect embellishment on the ring’s
                                shank, enhancing the appearance of the center diamond and making it look bigger.
                                <br><br>
                                The accent stones of these rings are usually set in a pavé or micro pavé setting. However,
                                french split, scalloped prongs, and channel settings have also become a popular choice in this
                                engagement ring style.
                                <br><br>
                                The most popular styles in side stone diamond rings are full eternity and half eternity rings.
                                The more unique rings among these feature double, twisted, or split shanks with small diamonds
                                on them.
                              </h6>
                              <NuxtLink class="modal_link radious_four"
                                :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'side-stone-engagement-rings' } })">
                                Shop Side Stone Rings</NuxtLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Teleport>  
              </ClientOnly>
              <!-- Modal -->
            </div>
            <div>
              <swiper 
              :modules="[SwiperAutoplay]"
              :loop="true" 
            :autoplay="{
              delay: 2500,
              disableOnInteraction: false
            }" 
            :breakpoints="{
              0: {
                slidesPerView: 1.5,
                slidesPerGroup: 1,
                centeredSlides: true,
              },
              513: {
                slidesPerView: 2,
                slidesPerGroup: 1,
               
              },
              767:{
                slidesPerView: 4,
                slidesPerGroup: 1,
              },
              1050: {
                slidesPerView: 5,
                slidesPerGroup: 1,
              },
            }"
            class="mySwiper">
              <swiper-slide>
              <div class="slide_box">
                <NuxtLink class="" :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'halo-engagement-rings' } })">
                  <picture>
                    <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/halo.webp">
                    <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg" src="~/assets/home/style/halo.jpg" alt="Halo Engagement Rings">
                  </picture>
                  <!-- <img loading="lazy" class="thumb" width="280" height="280" src="~/assets/home/style/halo.webp" alt="Halo Engagement Rings"></img> -->
                </NuxtLink>

                <span>Halo</span>
                <p class="mb-0" >Glamorous style with a centre stone surrounded by small diamonds.</p>
                
                <div class="open_modal mt-2" data-bs-toggle="modal" data-bs-target="#modal1">MORE INFO</div>
              </div> 
              </swiper-slide>

              <swiper-slide>
                <div class="slide_box">
                    <NuxtLink class="" :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'vintage-engagement-rings' } })">
                      <picture>
                        <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/vintage.webp">
                        <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                          src="~/assets/home/style/vintage.jpg" alt="Vintage Engagement Rings">
                      </picture>
                      <!-- <img loading="lazy" class="thumb" width="280" height="280" src="~asasets/home/style/vintage.webp" alt="Vintage Engagement Rings"></img> -->
                    </NuxtLink>

                    <span>Vintage</span>
                    <p class="mb-0">A treasured style inspired by the detailed designs of the vintage era.</p>
                    
                    <div class="open_modal mt-2" data-bs-toggle="modal" data-bs-target="#modal2">MORE INFO</div>
                </div> 
              </swiper-slide>

              <swiper-slide>
                <div class="slide_box">
                  <NuxtLink class=""
                    :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'solitaire-engagement-rings' } })">
                    <picture>
                      <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/solitaire.webp">
                      <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                        src="~/assets/home/style/solitaire.jpg" alt="Solitaire Engagement Rings">
                    </picture>
                  </NuxtLink>
                    <!-- <img loading="lazy" class="thumb" width="280" height="280" src="~/assets/home/style/solitaire.webp" alt="Solitaire Engagement Rings"></img> -->

                    <span>Solitaire</span>
                    <p class="mb-0" >A timeless and enduring style featuring a single centre diamond.</p>
                    
                    <div class="open_modal mt-2" data-bs-toggle="modal" data-bs-target="#modal3">MORE INFO</div>
                </div>
              </swiper-slide>

              <swiper-slide>
                <div class="slide_box">
                  <NuxtLink class=""
                  :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'three-stone-engagement-rings' } })">
                  <picture>
                    <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/three_stone.webp">
                    <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                      src="~/assets/home/style/three_stone.jpg" alt="Three Stone Engagement Rings">
                  </picture>
                  <!-- <img loading="lazy" class="thumb" width="280" height="280" src="~/assets/home/style/three_stone.jpg" alt="Vintage Engagement Rings"></img> -->
                </NuxtLink>
                <span>Three Stone</span>
                <p class="mb-0" >A classic style symbolising the past, present, and forever of love.</p>
                
                <div class="open_modal mt-2" data-bs-toggle="modal" data-bs-target="#modal4">MORE INFO</div>
                </div>
              </swiper-slide>

              <swiper-slide>
                <div class="slide_box">
                  <NuxtLink class=""
                    :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: 'side-stone-engagement-rings' } })">
                    <picture>
                      <source width="280" height="280" type="image/webp" srcset="~/assets/home/style/side_stone.webp">
                      <img loading="lazy" class="thumb" width="280" height="280" type="image/jpeg"
                        src="~/assets/home/style/side_stone.jpg" alt="Side Stone Engagement Rings">
                    </picture>
                    <!-- <b-img loading="lazy" class="thumb" width="280" height="280" src="~/assets/home/style/side_stone.webp" alt="Side Stone Engagement Rings"></b-img> -->
                  </NuxtLink>
                  <span>Side Stone</span>
                  <p class="mb-0" >A stunning and elegant style crafted with sparkling side diamonds.</p>
                  
                  <div class="open_modal mt-2" data-bs-toggle="modal" data-bs-target="#modal5">MORE INFO</div>
                  </div>
              </swiper-slide>

            </swiper>
            </div>
        </div>
</template>


<script setup>
   const localePath = useLocalePath();
</script>

<style scoped>
.largesvg {
    transform: scale(1.3);
}
.slide_box img{
    margin: 0 auto;
}
.header_box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.header_box span {
    padding: 0;
}
h6 {
    color: #6a6161;
    padding: 2% 0 3%;
    line-height: 1.4;
}
.modal_link {
    display: inline-block;
    font-size: 14px;
    color: #000;
    font-weight: 600;
    border: 1px solid #000;
    padding: 9px 15px;
    background: #fff;
    z-index: 999;
}

.slide_box .on_hover a, .slide_box .open_modal {
    font-size: 14px;
    color: #000;
    font-weight: 500;
    padding: 7px 0 0 0;
    background: #fff;
    cursor: pointer;
    text-decoration: underline;
}
.slide_box .on_hover{
    position: absolute;
    width: 99%;
    bottom: 24%;
    left: 0;
    visibility: hidden;
    transition: 0s;
    opacity: 0;
}
.slide_box img{
    transition: 0.5s;
}
.slide_box:hover img{
   transform: scale(1.1);
   transition: 0.5s;
}
.thumb{
    transition: 0s;
}

.modal-content {
  padding: 2%;
  border-radius: 8px;
}
.slide_box{
    text-align: center;
    position: relative;
}
h4{
    font-size: 30px;
}
p{
    font-weight: 500;
    color: #6a6161;
    padding: 0 4%;
}
a{
    display: inline-block;
}
span{
    font-size: 18px;
    text-transform: capitalize;
    font-weight: 600;
    display: block;
    text-align: center;
    color: #212529;
    padding: 5% 0;
}
.arrow_block{
    display: none;
}

.modal-header{
  border-bottom: none;
}

@media(max-width: 767px){
    h4{
        font-size: 24px;
    }
    span{
        font-size: 16px;

    }

}
@media(max-width: 512px){
    /* -------------- */
    .arrow_block{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 90%;
        margin: 0 auto;
    }
    .slick_arrow_up, .slick_arrow_down {
        position: relative;
        border: 0;
        height: 4px;
        width: 62px;
        margin-top: -40px;
    }
    .slick_arrow_up:before {
        position: absolute;
        content: "";
        height: 2px;
        width: 40px;
        background: #e2e2e2;
        top: 0;
        left: 25px;
    }
    .slick_arrow_up:after {
        position: absolute;
        content: "";
        height: 6px;
        width: 6px;
        top: -2px;
        left: 25px;
        border-top: 2px solid #e2e2e2;
        border-right: 2px solid #e2e2e2;
        transform: rotate(-135deg);
    }
    .slick_arrow_down:before {
        position: absolute;
        content: "";
        height: 2px;
        width: 40px;
        background: #e2e2e2;
        top: 0px;
        right: 25px;
    }
    .slick_arrow_down:after {
        position: absolute;
        content: "";
        height: 6px;
        width: 6px;
        top: -2px;
        right: 25px;
        border-top: 2px solid #e2e2e2;
        border-right: 2px solid #e2e2e2;
        transform: rotate(45deg);
    }
    /* -------------- */
    /* span{
        display: none;
    }
    .slick-slide.slick-active.slick-center.slick-current span {
        display: block;
    } */

}

</style>